import { formatCustomDate, newDate } from "helpers/dateTools";
import { CARBURETION_ACTIONS } from "./actions";
import { zeroFill } from "helpers/zeroFill";

const {
  SEARCH_INPUTS,
  GET_CARBURATIONS,
  ADD_CARBURATION,
  EDIT_CARBURATION,
  DELETE_CARBURATION,
  UPDATE_CARBURETION_DATE,
  RESTORE_INITIAL,
  GET_UNIT_CONFIGS,
  UPDATE_UNIT_CONFIG_FILLING_ORDER,
} = CARBURETION_ACTIONS;


const initialState = {
  startDate: formatCustomDate(new Date(), '-'),
  endDate: formatCustomDate(new Date(), '-'),
  station: null,
  carburations: [],
  realCarburetionTotal: 0,
  unitConfigs: [],
};

export const carburationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case GET_CARBURATIONS:
      const carburetions = payload.map(carb => {
        return {
          ...carb,
          sgc: carb.fillingOrder?.fillingStation,
          order: carb.fillingOrder?.numberOrderExtra ? zeroFill(carb.fillingOrder?.numberOrderExtra) : '',
          chargedVolumeStatus: carb?.chargedVolume
        };
      });
      const counter = carburetions.reduce((acc, carb) => {
        return acc + carb?.chargedVolume || 0
      }, 0);

      return {
        ...state,
        carburations: carburetions,
        realCarburetionTotal: counter
      };          
    case ADD_CARBURATION:
      const extendedCarburation = {
        ...payload,
        chargedVolumeStatus: payload?.chargedVolume
      };
      return {
        ...state,
        carburations: [...state.carburations, extendedCarburation]
      };
    case EDIT_CARBURATION:
      const editCarburations = [...state.carburations];
      const idx = editCarburations.findIndex(carburation => carburation.id === payload.id);
      if (idx === -1) return state;
      
      editCarburations[idx] = payload;
      return {
        ...state,
        carburations: editCarburations
      };
    case DELETE_CARBURATION:
      return {
        ...state,
        carburations: state.carburations.filter(carburation => carburation.id !== payload)
      };
    case UPDATE_CARBURETION_DATE:
      let updateDate = [...state.carburations];
      const idxDate = updateDate.findIndex(car => car.id === payload.id);
      if (idxDate === -1) return state;
      updateDate[idxDate] = {
        ...updateDate[idxDate],
        date: newDate({
          date:payload.date
        })
      };
      return { ...state, carburations: updateDate };
    case GET_UNIT_CONFIGS: {
      const unitConfigs = payload.units?.map(u => {
        return {
          id: u.id,
          value: u.id,
          label: u.number,
          config: u.conf
        };
      }) || [];
      return {
        ...state,
        unitConfigs
      };
    }
    case UPDATE_UNIT_CONFIG_FILLING_ORDER: {
      const updatedConfigs = state.unitConfigs.map(u => {
        if (u.id === payload.id) {
          return {
            ...u,
            config: {
              ...u.config,
              showFillingOrder: payload.showFillingOrder
            }
          };
        }
        return u;
      });
      return {
        ...state,
        unitConfigs: updatedConfigs
      };
    }
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
}